<template>
  <div class="assist-product-benefit-container">
    <p class="assist-product-benefit-title">
      <span
        class="product-title"
        :class="
          whitelabel.estateAssistEnabled ? '' : 'cost-assist-title-product'
        "
        >{{ boldText }}</span
      >
      <span>{{ normalText }}</span>
    </p>
    <div class="seporator-from-title" v-if="coloredText"></div>
    <h1>{{ coloredText }}</h1>
  </div>
</template>

<script>
  export default {
    name: 'AssistProductBenefitTitle',
    props: {
      coloredText: {
        required: false,
        default: '',
        type: String,
      },
      boldText: {
        required: true,
        default: '',
        type: String,
      },
      normalText: {
        required: true,
        default: '',
        type: String,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cost-assist-title-product {
    text-decoration: underline;
    color: #e9ab21;
  }

  .assist-product-benefit-container {
    display: flex;
    align-items: center;

    .seporator-from-title {
      background-color: #ed0080;
      width: 2px;
      height: 20px;
      margin-left: 4px;
      margin-right: 4px;
    }

    h1 {
      color: #ed0080;
      font-size: 24px;
      font-weight: 600;
      line-height: 36px;
      text-wrap: nowrap;
    }

    .assist-product-benefit-title {
      margin: 0;
      margin-top: 2px;
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      text-wrap: nowrap;

      span {
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        text-wrap: nowrap;
      }

      .product-title {
        font-weight: 700;
      }
    }
  }
</style>
